module.exports = __webpack_public_path__ + "img/mall-invite-image.6527c9b3.png";